<template>
    <div>
        <add-form></add-form>
        <products-table :consumptions="consumptions" @remove="removeConsumption">
            <filters-bar v-if="showFilters" :filters="searchFilters"
                         :agencies="agencies" @update="updateFilters">
            </filters-bar>
        </products-table>
    </div>
</template>

<script>
    import {mapMutations, mapActions, mapGetters, mapState} from 'vuex'
    import AddForm from 'components/ConsumptionProducts/AddForm'
    import ProductsTable from 'components/ConsumptionProducts/ProductsTable'
    import FiltersBar from 'components/ConsumptionProducts/FiltersBar'

    export default {

        components: {
            AddForm,
            ProductsTable,
            FiltersBar,
          
        },

        data () {
            return {

            }
        },

        created () {
            const cond =  () => {
                return !_.isNil(this.userAgencies) && this.userAgencies.length > 0
            }, startingFilters = () => ({
                agencies: _.map(this.userAgencies, 'id'),
                date: moment().format('YYYY-MM-DD')
            })

            if (cond()) {
                this.updateFilters(startingFilters())
            } else {
                const unwatchUserAgencies = this.$watch(
                    cond,
                    function () {
                        this.updateFilters(startingFilters())
                        this.$nextTick()
                            .then(() => unwatchUserAgencies())
                    })
            }
        },

        methods: {
            ...mapActions('consumptions', [
                'removeConsumption',
                'updateFilters'
            ])
        },

        computed: {
            ...mapState('consumptions', [
                'consumptions',
                'searchFilters'
            ]),

            ...mapState({
                userAgencies: state => state.user.agencies
            }),

            showFilters () {
                return this.userAgencies.length && this.agencies.length && !_.isEmpty(this.searchFilters)
            },

            ...mapGetters('consumptions', {
                agencies: 'selectAgenciesList'
            })
        },
    }
</script>

<style>
    .consumptions-list, .consumption-form {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// client/views/ConsumptionProducts.vue